<template>
	<div class="operation_box">
		<div class="operation_item">
			<el-tooltip placement="top" :content="$t('revolvingPutOption.table.operation.acceptOffer.publishingIntervalNotFinished.tooltip')"
						:open-delay="300"
						:disabled="params.canAccept"
			>
				<md-button :class="{ 'md-primary': params.canAccept }" @click="click">
					{{ $t("common.button.accept")}}
				</md-button>
			</el-tooltip>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		click() {
			if (!this.params.canAccept) {
				return;
			}

			this.params.accept(this.params.data);
		}
	},
};
</script>